import { render, staticRenderFns } from "./SuccessOrFailure.vue?vue&type=template&id=9a50ba56&scoped=true&"
import script from "./SuccessOrFailure.vue?vue&type=script&lang=js&"
export * from "./SuccessOrFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a50ba56",
  null
  
)

export default component.exports